export const isoToDate = (iso) => (iso ? new Date(`${iso}T00:00:00`) : null);

export const dateToIso = (date) => {
  if (!date) return "";
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

// can't select the same day as the start date — only strictly later dates.
export const getNextDay = (date) => {
  if (!date) return undefined;
  const next = new Date(date);
  next.setDate(next.getDate() + 1);
  return next;
};

export const getPrevDay = (date) => {
  if (!date) return undefined;
  const prev = new Date(date);
  prev.setDate(prev.getDate() - 1);
  return prev;
};
// Turns { "2026-09-02": { "14": [features], "15": [features] } }
// into a flat, chronologically sorted array: [{ timestamp, features }, ...]
export const flattenFireBuckets = (rawData, minutes = "00") => {
  if (!rawData || typeof rawData !== "object") return [];

  const safeMinutes = /^\d{2}$/.test(minutes) ? minutes : "00";

  const buckets = [];
  Object.entries(rawData).forEach(([dateStr, hours]) => {
    if (!hours || typeof hours !== "object") return;
    Object.entries(hours).forEach(([hourStr, features]) => {
      if (!Array.isArray(features)) return;
      const timestamp = new Date(`${dateStr}T${hourStr}:${safeMinutes}:00`);
      if (isNaN(timestamp.getTime())) return;
      buckets.push({ timestamp, features });
    });
  });

  buckets.sort((a, b) => a.timestamp - b.timestamp);
  return buckets;
};
export const getLocalNowTimeStr = () => {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(now.getHours())}:${pad(now.getMinutes())}`;
};

export const isToday = (iso) => {
  const d = isoToDate(iso);
  if (!d) return false;
  const now = new Date();
  return (
    d.getFullYear() === now.getFullYear() &&
    d.getMonth() === now.getMonth() &&
    d.getDate() === now.getDate()
  );
};